import styled from 'styled-components';
import photo1 from 'assets/images/photo1.jpg';

export const Container = styled.header`
  display: flex;
  width: 100%;

  @media screen and (max-width: 1000px) {
    flex-direction: column-reverse;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50%;

  &.left {
    padding: 32px;
    height: 100vh;
  }

  @media screen and (max-width: 1000px) {
    width: 100%;

    &.left {
      height: auto;
      padding: 56px 32px;
    }
  }
`;

export const Photo = styled.img.attrs({ src: photo1 })`
  width: 100%;
  margin-bottom: 16px;
`;

export const Legend = styled.div`
  font-size: 16px;
  line-height: 26px;
  width: 100%;

  @media screen and (max-width: 1000px) {
    padding: 0 32px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 485px;

  @media screen and (max-width: 1000px) {
    max-width: 100%;
  }
`;

export const Title = styled.h1`
  font-size: 68px;
  line-height: 68px;
  margin-bottom: 24px;
`;

export const Text = styled.article`
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 48px;
`;

export const Credits = styled.div`
  padding-top: 48px;
  font-size: 16px;
  line-height: 26px;
  text-transform: uppercase;
  position: relative;

  span {
    text-transform: none;
  }

  :before {
    content: '';
    display: block;
    width: 80px;
    height: 1px;
    background-color: #000;
    position: absolute;
    top: 0;
  }
`;
